export default __webpack_public_path__ + "static/media/topcharacter4.3c90962d.jpeg";